// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

const FileTxtIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 217.439 256">
        <path
          data-name="Trazado 426"
          d="M216.997 77.194c.388-15.753.958-32.242-.5-47.941-1.094-11.756-6.193-21.735-17.831-25.914a42.44 42.44 0 00-5.017-1.448c-6.549-1.478-13.432-1.6-20.09-1.8-11.726-.343-23.448.366-35.175.314-23.493-.1-46.985.323-70.479.414q-4.228.018-8.455.017H17.243A17.26 17.26 0 00.002 18.077v220.679a17.261 17.261 0 0017.241 17.241h182.542a17.26 17.26 0 0017.24-17.241V128.812c.001-17.183-.45-34.459-.028-51.618zm-20.922 145.988a14.888 14.888 0 01-14.888 14.888H32.818a14.888 14.888 0 01-14.892-14.884V33.658A14.888 14.888 0 0132.814 18.77h99.548v25.459a37.8 37.8 0 0037.764 37.757h25.951zm0-157.656h-25.949a21.321 21.321 0 01-21.3-21.3V18.767h32.359a14.888 14.888 0 0114.888 14.888z"
        />
        <path
          data-name="Trazado 427"
          d="M111.987 69.289h-69.1a8.455 8.455 0 01-8.455-8.455 8.455 8.455 0 018.455-8.455h69.1a8.455 8.455 0 018.455 8.455 8.455 8.455 0 01-8.455 8.455z"
        />
        <path
          data-name="Trazado 428"
          d="M111.987 102.604h-69.1a8.455 8.455 0 01-8.455-8.455 8.455 8.455 0 018.455-8.455h69.1a8.455 8.455 0 018.455 8.455 8.455 8.455 0 01-8.455 8.455z"
        />
        <path
          data-name="Trazado 429"
          d="M164.893 136.455H42.878A8.455 8.455 0 0134.423 128a8.455 8.455 0 018.455-8.455h122.011a8.455 8.455 0 018.455 8.455 8.455 8.455 0 01-8.451 8.455z"
        />
        <path
          data-name="Trazado 430"
          d="M164.893 170.306H42.878a8.455 8.455 0 01-8.455-8.455 8.455 8.455 0 018.455-8.455h122.011a8.455 8.455 0 018.455 8.455 8.455 8.455 0 01-8.451 8.455z"
        />
        <path
          data-name="Trazado 431"
          d="M164.893 204.161H42.878a8.455 8.455 0 01-8.455-8.455 8.455 8.455 0 018.455-8.455h122.011a8.455 8.455 0 018.455 8.455 8.455 8.455 0 01-8.451 8.455z"
        />
      </svg>
    </SvgIcon>
  );
};

export default FileTxtIcon;
